import type {Logger, LogLevel} from 'core/logging/types';
import {serializeArg} from 'core/debug-util/utils';
import {LOG_LEVEL_TO_LABEL, LOG_LEVELS} from 'core/logging/constants';


export class InMemoryLogger implements Logger {
    private readonly logHistory: string[] = [];

    constructor(private readonly bufferSize: number) {
    }

    trace(...data: any[]): void {
        this.log(LOG_LEVELS.TRACE,...data);
    }

    debug(...data: any[]): void {
        this.log(LOG_LEVELS.DEBUG,...data);
    }

    info(...data: any[]): void {
        this.log(LOG_LEVELS.INFO,...data);
    }

    warn(...data: any[]): void {
        this.log(LOG_LEVELS.WARN,...data);
    }

    error(...data: any[]): void {
        this.log(LOG_LEVELS.ERROR,...data);
    }

    public dumpLogHistory(): string[] {
        return structuredClone(this.logHistory);
    }

    private log(level: LogLevel, ...data: any[]): void {
        this.logHistory.push(`${this.timestamp()} ${LOG_LEVEL_TO_LABEL[level]} ${this.message(...data)}`);

        // Limit log history to prevent memory issues
        if (this.logHistory.length > this.bufferSize) {
            this.logHistory.shift();
        }
    }

    private message(...args: any[]): string {
        return args.map(serializeArg).join(' ');
    }

    private timestamp() {
        return new Date().toISOString();
    }
}